import { UserActionKey, UserFilterTabKey } from './user-list.enums';
import { ActionList } from '../../../../../common/models/action-list.model';
import {
  TableColumns,
  TableFilterTab,
} from '../../../../../../ui-components/lib/table/table.model';

export const USERS_DATABASE_COLUMNS_SORT: TableColumns[] = [
  { header: '' },
  {
    header: 'users_database_screen_name_header_title',
    showViewIcon: true,
    isSortable: true,
    sortKey: 'name][type',
  },
  {
    header: 'users_database_screen_department_header_title',
    isSortable: true,
    sortKey: 'department][type',
  },
  {
    header: 'users_database_screen_job_titles_header_title',
    isSortable: true,
    sortKey: 'job_title][type',
  },
  {
    header: 'users_database_screen_placement_type_header_title',
    identifier: 'placement_type',
    isSortable: false,
  },
  {
    header: 'users_database_screen_last_access_header_title',
    isSortable: true,
    sortKey: 'last_accessed_at][type',
  },
  {
    header: 'users_database_screen_portal_access_header_title',
    identifier: 'portal_access',
    isSortable: false,
  },
  {
    header: 'users_database_screen_status_header_title',
    identifier: 'status',
    isSortable: true,
    sortKey: 'state][type',
  },
  { header: '' },
];

export const USERS_DATABASE_VIEW_DETAILS_ACTION: ActionList = {
  key: UserActionKey.VIEW_DETAILS,
  hasIcon: true,
  label: 'view_details_action_item',
  hasDivider: false,
  labelCustomStyle: '',
  hasToggle: false,
  toggleValue: false,
  isLink: true,
};

export const USERS_DATABASE_EDIT_ACTION: ActionList = {
  key: UserActionKey.EDIT,
  hasIcon: true,
  label: 'edit_action_item',
  hasDivider: true,
  labelCustomStyle: '',
  hasToggle: false,
  isLink: true,
};

export const USERS_DATABASE_REINVITE_ACTION: ActionList = {
  key: UserActionKey.REINVITE,
  hasIcon: true,
  label: 'users_database_screen_reinvite_action_item',
  hasDivider: false,
  labelCustomStyle: '',
  hasToggle: false,
};

export const USERS_DATABASE_SEND_INVITATION_ACTION: ActionList = {
  key: UserActionKey.SEND_INVITATION,
  hasIcon: true,
  label: 'users_database_screen_send_invitation_action_item',
  hasDivider: false,
  labelCustomStyle: '',
  hasToggle: false,
};

export const USERS_DATABASE_CANCEL_INVITATION_ACTION: ActionList = {
  key: UserActionKey.CANCEL_INVITATION,
  hasIcon: true,
  label: 'users_database_screen_cancel_invitation_action_item',
  hasDivider: false,
  labelCustomStyle: '',
  hasToggle: false,
};

export const USERS_DATABASE_DELETE_ACTION: ActionList = {
  key: UserActionKey.DELETE,
  hasIcon: true,
  label: 'delete_action_item',
  hasDivider: false,
  labelCustomStyle: 'text-destructive-500',
  hasToggle: false,
};

export const USERS_DATABASE_ACTIVE_ACTIONS: ActionList[] = [
  {
    key: UserActionKey.DEACTIVATE,
    hasIcon: true,
    label: 'users_database_screen_deactivate_user_action_item',
    hasDivider: false,
    labelCustomStyle: 'text-destructive-500',
    hasToggle: false,
  },
  {
    key: UserActionKey.RESET_PASSWORD,
    hasIcon: true,
    label: 'users_database_screen_reset_password_action_item',
    hasDivider: false,
    labelCustomStyle: '',
    hasToggle: false,
  },
];

export const USERS_DATABASE_INACTIVE_ACTIONS: ActionList[] = [
  {
    key: UserActionKey.ACTIVATE,
    hasIcon: true,
    label: 'users_database_screen_activate_user_action_item',
    hasDivider: false,
    labelCustomStyle: '',
    hasToggle: false,
  },
];

export const USERS_DATABASE_REMOVE_EMPLOYEE_ROLE_ACTION: ActionList = {
  key: UserActionKey.REMOVE_EMPLOYEE_ROLE,
  hasIcon: true,
  label: 'users_database_screen_remove_employee_role_action_item',
  hasDivider: false,
  labelCustomStyle: '',
  hasToggle: false,
};

export const USERS_DATABASE_GRANT_EMPLOYEE_ROLE_ACTION: ActionList = {
  key: UserActionKey.GRANT_EMPLOYEE_ROLE,
  hasIcon: true,
  label: 'users_database_screen_grant_employee_role_action_item',
  hasDivider: false,
  labelCustomStyle: '',
  hasToggle: false,
};

export const USERS_DATABASE_FILTER_TABS: TableFilterTab[] = [
  {
    key: UserFilterTabKey.ACTIVE,
    identifier: 'active',
    label: 'table_filter_tab_active_label',
    active: true,
    iconName: 'active',
  },
  {
    key: UserFilterTabKey.ACTIVATED_BEFORE,
    identifier: 'newly_added',
    label: 'table_filter_tab_newly_added_label',
    active: false,
    iconName: 'add-user',
  },
  {
    key: UserFilterTabKey.PENDING,
    identifier: 'pending',
    label: 'table_filter_tab_pending_label',
    active: false,
    iconName: 'pending',
  },
  {
    key: UserFilterTabKey.EXPIRED,
    identifier: 'expired',
    label: 'table_filter_tab_expired_label',
    active: false,
    iconName: 'expired',
  },
  {
    key: UserFilterTabKey.DRAFT,
    identifier: 'draft',
    label: 'table_filter_tab_draft_label',
    active: false,
    iconName: 'draft',
  },
  {
    key: UserFilterTabKey.CANCELLED,
    identifier: 'cancelled',
    label: 'table_filter_tab_cancelled_label',
    active: false,
    iconName: 'cancelled',
  },
  {
    key: UserFilterTabKey.INACTIVE,
    identifier: 'inactive',
    label: 'table_filter_tab_inactive_label',
    active: false,
    iconName: 'inactive',
  },
  {
    key: UserFilterTabKey.ALL,
    identifier: 'all',
    label: 'table_filter_tab_all_label',
    active: false,
    iconName: 'all',
  },
];
